export default "__VITE_ASSET__86aba86d__"